module.exports = __webpack_public_path__ + "static/media/starProduct6.6d69623c.png";